let Values = {
  R: "R",
  D: "D",
  "R-ESP": "R-ESP",
  "D-ESP": "D-ESP",
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  byPrefix: (prefix) => {
    switch (prefix) {
      case "D":
        return Values.D;
      case "R":
        return Values.R;
      case "D-ESP":
        return Values["D-ESP"];
      case "R-ESP":
        return Values["R-ESP"];
      default:
        console.error("Reached default case");
        break;
    }
  },

  /* Get name for value. */
  name: (value) => {
    switch (value) {
      case Values.D:
        return "DEBUG WIFI TI";
      case Values.R:
        return "RELEASE WIFI TI";
      case Values["D-ESP"]:
        return "DEBUG WIFI ESP32";
      case Values["R-ESP"]:
        return "RELEASE WIFI ESP32";
      default:
        console.error("Reached default case");
        break;
    }
  },

  /* Get color for value. */
  color: (value) => {
    switch (value) {
      case Values.D:
        return "yellow";
      case Values.R:
        return "green";
      case Values["D-ESP"]:
        return "orange";
      case Values["R-ESP"]:
        return "blue";
      default:
        console.error("Reached default case");
        break;
    }
  },
});
